import { useState, useEffect } from 'react';
import { OwcButton, OwcLogo, OwcProgressSpinner } from '@one/react';
import styles from './SignupPage.module.css';
function SignInScreen({ auth, isSigningIn, setIsSigningIn }) {
  const [showOverlay, setShowOverlay] = useState(false);

  const handleSignIn = () => {
    setIsSigningIn(true);
    setShowOverlay(true);
    // Give time for overlay to render before redirecting for visual transition
    setTimeout(() => {
      auth.signinRedirect();
    }, 600);
  };

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Enter') handleSignIn();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  return (
    <div className={styles.signupage_container}>
      <div>
        {/* Roche logo */}
        <OwcLogo className=" sc-owc-logo-h  owc-logo--size-standard" />
        <h2 className={styles.signup_container_header}>Welcome to Data Landscape Integration</h2>
        <p className={styles.signup_page_description}>
          A single unified platform for centralized, standardized organizational data
        </p>
        <div className={styles.signup_button_container}>
          <OwcButton
            variant="primary"
            size="medium"
            onClick={handleSignIn}
            disabled={isSigningIn}
            style={{ opacity: isSigningIn ? 0.6 : 1 }}
          >
            {isSigningIn ? 'Signing in...' : 'Sign In'}
          </OwcButton>
        </div>
        {showOverlay && (
          <div className={styles.overlay_container}>
            <OwcProgressSpinner size="xxLarge" />
            <div className={styles.signup_redirection_text}>Redirecting to login…</div>
          </div>
        )}
      </div>
    </div>
  );
}

export default SignInScreen;
